module.exports = __webpack_public_path__ + "img/data-goods.40758cbb.svg";